const STORAGE_KEY = 'disgenet_academicUpgradeRibbonDismissedDate';

function localCalendarDateKey(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function readStoredDismissDate(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function isAcademicRibbonDismissedToday(now: Date = new Date()): boolean {
  const stored = readStoredDismissDate();
  if (!stored) return false;
  return stored === localCalendarDateKey(now);
}

export function dismissAcademicRibbonForToday(now: Date = new Date()): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, localCalendarDateKey(now));
  } catch {
    /* ignore quota / private mode */
  }
}
